import { SeoHeader } from '@travelata-libs/travelata-frontend';
import Vue from 'vue';
import { getSsrMountTarget, parseJsonAttribute } from '@shared/lib';
import { createHeaderBindings } from './headerBindings';

const HOST_ANCHOR_SELECTOR = '#js-lib-seo-header';

// Без якоря ничего не делает — зовётся на всех страницах.
export function mountLibSeoHeader(): void {
    if (typeof document === 'undefined') {
        return;
    }

    const anchor = document.querySelector(HOST_ANCHOR_SELECTOR);
    if (!anchor) {
        return;
    }

    const props = parseJsonAttribute(anchor, 'data-seo-header-props', {});
    const header = createHeaderBindings();

    new Vue({
        name: 'LibSeoHeaderRoot',
        render: (createElement) => createElement(SeoHeader, {
            props: { ...props, ...header.props, user: header.auth.user },
            on: header.listeners,
        }),
    }).$mount(getSsrMountTarget(anchor));
}
